<template>
  <div class="products-table-header">
    <BaseText class="table-header-text">Produto</BaseText>
    <BaseText class="table-header-text">Valor Disponível</BaseText>
    <BaseText class="table-header-text">Mínimo para resgate</BaseText>
    <BaseText class="table-header-text">Mínimo de permanência</BaseText>
    <BaseText class="table-header-text">Resgate</BaseText>
    <BaseText class="table-header-text">Valor a resgatar</BaseText>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import { BaseText } from '@warrenbrasil/nebraska-web';

@Component({
  components: { BaseText }
})
export default class ProductsToWithdrawHeader extends Vue {}
</script>
<style lang="less" scoped>
.products-table-header {
  display: grid;
  grid-template-columns: 3fr 1.1fr 1.3fr 1.5fr 1fr 1.5fr;
  gap: @size-spacing-x400;
  border-bottom: 1px solid @divider-primary;
}
.table-header-text {
  padding: @size-spacing-x600 0px @size-spacing-x600 0;
  .text-p-6();
  font-weight: 600;
}
</style>
